export default __webpack_public_path__ + "static/media/software_engineer.b5db170b.png";